export const english = {
  lang: 'en',
  data: {
    titles: {
      course: 'Course',
      course_overview: 'About the course types',
      classroom_course: 'Physical courses',
      digital_course: 'Digital courses',
      provider_course: 'Courses from providers',
      about: 'About',
      course_content: 'Course content',
      course_request: 'Do you miss course?',
    },
    subtitles: {
      course_overview: 'Here you will find an overview of all physical and digital courses offered at RS Sjøliv. The physical courses are delivered by external instructors who are all verified by the Rescue Company. From 1 June this year, you must have a High Speed ​​Certificate if you are going to drive a boat that can go over 50 knots.',
      classroom_course: 'The courses at Sjøliv are delivered by independent instructors. To become an instructor, you must be verified by RS. Do you want to offer courses?',
      digital_course: 'With our digital courses you can learn where and when you want!',
      provider_course: 'The courses at Sjøliv are delivered by independent instructors. To become an instructor, you must be verified by RS.',
      course_request: 'Here you can enter the type(s) of course you want, where in the country you want it and possibly the instructor. This information will be sent to relevant instructors when four or more people want the same course as you. If a course is set up that suits your wishes, we will send you an e-mail about this.',
    },
    action_buttons: {
      save:'Save',
      clear: 'Clear',
      see_course: 'See course',
      template_send_request: 'Are you missing a course?',
      send_request: 'Send in request',
    },
    course_request_form: {
      name: {
        label: 'Name',
        placeholder: 'Name'
      },
      email: {
        label: 'Email',
        placeholder: 'Email'
      },
      confirm_email: {
        label: 'Confirm Email',
        placeholder: 'Email'
      },
      wanted_course: {
        label: 'What course(s) do you want?',
        placeholder: 'Choose course'
      },
      region: {
        label: 'Choose region',
        placeholder: 'Choose region'
      },
      comment: {
        label: 'Comment',
        placeholder: 'Feel free to send a comment'
      }
    },
    availableSlots: 'available course dates',
    availableSlot: 'available course date',
    noSlot: 'No available course dates',
    duration: 'Duration',
    hour: 'Hour',
    hours: 'Hours',
    availableCourses: 'Available Courses',
    description: 'Description',
    exam: 'Exam',
    practical_part: 'Practical part',
    yes: 'Yes',
    no: 'No',
    course: 'Course',
    region: 'Region',
    reset: 'Reset',
    date: 'Date',
    search: 'SEARCH',
    no_course_available: 'No courses available yet',
    rs_member: 'RS-member',
    rs_non_member: 'Price',
    read_more: 'Read more',
    read_more_here: 'Read more here',
    read_more_about_evidence_here: 'Read more about the evidence here.',
    read_less: 'Read less',
    notifications: {
      course_request_success: 'Your request has been received'
    }
  },
};
